import React from 'react';
import PropTypes from 'prop-types';

import SaveButton from 'components/form/save_button';

import { connect } from 'react-redux';
import { clearWorkflowSaved, saveWorkflow } from './store/workflow/actions';

export class TaskWorkflowEditorHeader extends React.Component {
  static propTypes = {
    clearWorkflowSaved: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    saveWorkflow: PropTypes.func.isRequired,
    workflow: PropTypes.shape({
      errors: PropTypes.array,
      saved: PropTypes.bool,
      saving: PropTypes.bool
    }).isRequired
  }

  render() {
    return <React.Fragment>
      <div className="task-workflow-header">
        <h2>{this.props.header}</h2>
        <SaveButton
          label="Save Workflow"
          saved={this.props.workflow.saved}
          saving={this.props.workflow.saving}
          onClick={this.props.saveWorkflow}
          onSavedAcknowledgement={this.props.clearWorkflowSaved}
        />
      </div>

      <div className="mb-3">{this.props.description}</div>
      <div className="mb-3 text-danger">{(this.props.workflow.errors || []).join(', ')}</div>
    </React.Fragment>;
  }
}

const mapStateToProps = state => ({
  description: state.static.description,
  header: state.static.header,
  workflow: state.workflow
});

const mapDispatchToProps = {
  clearWorkflowSaved,
  saveWorkflow
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskWorkflowEditorHeader);
